import { _ as __rest } from '../../../tslib.es6-c563c1dd.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { AppBar, Toolbar, Hidden, IconButton, SvgIcon, Box } from '@mui/material';
import { Menu } from 'react-feather';
import { THEMES } from '../../../global/constants/index.js';
import { Logo } from '../../../components/Logo.js';
import { Account } from './Account.js';
import { Settings } from './Settings.js';
import { Portals } from './Portals.js';
import 'react';
import 'react-router';
import 'notistack';
import '../../../components/AvatarSwitch.js';
import '../../../utils/getInitials.js';
import './Debugger/index.js';
import 'moment';
import '../../../utils/msToTime.js';
import './Debugger/DebugFile.js';
import '../../../utils/clipboardCopy.js';
import 'change-case';
import '../../../hooks/useSettings.js';
import '../../../contexts/SettingsContext.js';
import 'react-device-detect';
import '../../../components/Icons/PortalsIcon.js';
import '@mui/material/utils';
import './PortalLink.js';

const PREFIX = 'TopBar';
const classes = {
    root: `${PREFIX}-root`,
    toolbar: `${PREFIX}-toolbar`,
};
const StyledAppBar = styled(AppBar)(({ theme }) => ({
    [`&.${classes.root}`]: Object.assign(Object.assign({ zIndex: theme.zIndex.drawer + 100 }, (theme.name === THEMES.CIGAM
        ? {
            boxShadow: 'none',
            backgroundColor: theme.palette.primary.main,
        }
        : {})), (theme.name === THEMES.ESCURO
        ? {
            backgroundColor: theme.palette.background.default,
        }
        : {})),
    [`& .${classes.toolbar}`]: {
        minHeight: 64,
    },
}));
const TopBar = (_a) => {
    var { className, onMobileNavOpen, themes, user, logService, logAxios, logMonitorUrl, logout, aplicacoes } = _a, rest = __rest(_a, ["className", "onMobileNavOpen", "themes", "user", "logService", "logAxios", "logMonitorUrl", "logout", "aplicacoes"]);
    return (jsx(StyledAppBar, Object.assign({ className: clsx(classes.root, className) }, rest, { children: jsxs(Toolbar, Object.assign({ className: classes.toolbar }, { children: [jsx(Hidden, Object.assign({ lgUp: true }, { children: jsx(IconButton, Object.assign({ color: "inherit", onClick: onMobileNavOpen }, { children: jsx(SvgIcon, Object.assign({ fontSize: "small" }, { children: jsx(Menu, {}) })) })) })), jsx(Hidden, Object.assign({ lgDown: true }, { children: jsx(Link, Object.assign({ to: "/" }, { children: jsx(Logo, {}) })) })), jsx(Box, { ml: 2, flexGrow: 1 }), jsx(Portals, { aplicacoes: aplicacoes }), jsx(Settings, { themes: themes }), jsx(Box, Object.assign({ ml: 2 }, { children: jsx(Account, { user: user, logService: logService, logAxios: logAxios, logMonitorUrl: logMonitorUrl, logout: logout }) }))] })) })));
};

export { TopBar };
